import { get, post } from './client';
import type {
  AuthTokens,
  UserSafe,
  LoginRequest,
  RegisterRequest,
  RefreshRequest,
} from './types';

/** 登录 */
export function login(data: LoginRequest): Promise<AuthTokens> {
  return post<AuthTokens>('/auth/login', data);
}

/** 注册 */
export function register(data: RegisterRequest): Promise<UserSafe> {
  return post<UserSafe>('/auth/register', data);
}

/** 刷新 access token */
export function refresh(data: RefreshRequest): Promise<AuthTokens> {
  return post<AuthTokens>('/auth/refresh', data);
}

/** 登出 */
export function logout(refreshToken?: string): Promise<void> {
  return post<void>('/auth/logout', { refresh_token: refreshToken });
}

/** 获取当前用户信息 */
export function me(): Promise<UserSafe> {
  return get<UserSafe>('/auth/me');
}
